module.exports = __webpack_public_path__ + "static/russland-26e09664762e1d8bff0e24bc02775ead.svg";